import React, { Component } from "react";
import * as s from "./Paginator.module.scss";
import { P, Progressbar, Button, Col } from "src/views/shared/components";
import { Icons } from "src/libs/assets";
import { inject, observer } from "mobx-react";
import { UIStore } from "src/stores";
import { tx } from "src/libs/i18n";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  numberOfPages: number;
  currentPage: number;
  setPage: any;
  uiStore?: UIStore;
}

@inject("uiStore")
@observer
export class Paginator extends Component<Props> {
  constructor(props) {
    super(props);
  }

  calculateProgress = () => {
    const { numberOfPages, currentPage } = this.props;
    let calculatedProgress;
    if (currentPage < numberOfPages) {
      calculatedProgress = currentPage / numberOfPages;
    } else if (currentPage === numberOfPages) {
      calculatedProgress = 100;
    }

    return calculatedProgress;
  };

  renderPageIndicatorText = () => {
    const { numberOfPages, currentPage } = this.props;

    return (
      <div className={s.pageIndicatorTextContainer}>
        <P className={s.pageIndicatorText}>
          {tx("paginator.pageOf", { currentPage, numberOfPages })}
        </P>
      </div>
    );
  };

  renderPageButtonsContainer = () => {
    const { currentPage, numberOfPages, uiStore } = this.props;
    const { isDesktop } = uiStore;
    let maxBtnCount = isDesktop ? 7 : 5;
    let btnsAfter = isDesktop ? 3 : 1;
    let btnsBefore = 3;

    let addTruncation = currentPage <= numberOfPages - maxBtnCount;

    let buttons = [];
    if (numberOfPages > maxBtnCount) {
      if (addTruncation) {
        for (let i = currentPage - 1; i < currentPage + (btnsBefore - 1); i++) {
          buttons.push(this.createPageButton(i));
        }
        buttons.push(this.createTruncationButton());
        for (let i = numberOfPages - btnsAfter; i < numberOfPages; i++) {
          buttons.push(this.createPageButton(i));
        }
      } else {
        for (let i = numberOfPages - maxBtnCount; i < numberOfPages; i++) {
          buttons.push(this.createPageButton(i));
        }
      }
    } else {
      for (let i = 0; i < numberOfPages; i++) {
        buttons.push(this.createPageButton(i));
      }
    }

    return <div className={s.pageButtonsContainer}>{buttons}</div>;
  };

  renderJumpToPage = () => {
    const { numberOfPages } = this.props;

    return (
      <div className={s.jumpToPageContainer}>
        <P small className={s.jumpToPageLabel}>
          {tx("paginator.jumpToPage")}
        </P>
        <input
          type="number"
          min={1}
          max={numberOfPages}
          className={s.jumpToPageInputField}
          onKeyUp={this.jumpToPage}
        />
      </div>
    );
  };

  createTruncationButton = () => {
    return (
      <div className={s.truncationButton}>
        <P className={s.truncationButtonLabel}>...</P>
      </div>
    );
  };

  createPageButton = number => {
    const { currentPage, setPage } = this.props;
    const pageNumber = number + 1;

    let selected = currentPage === pageNumber;
    return (
      <Button
        className={s.pageButton}
        size="small"
        color={selected ? "red" : "white"}
        onClick={() => setPage(pageNumber)}
      >
        {pageNumber}
      </Button>
    );
  };

  onPreviousPageClick = () => {
    const { currentPage, setPage } = this.props;

    if (currentPage > 1) {
      setPage(currentPage - 1);
    }
  };

  onNextPageClick = () => {
    const { currentPage, numberOfPages, setPage } = this.props;
    if (currentPage < numberOfPages) {
      setPage(currentPage + 1);
    }
  };

  jumpToPage = e => {
    const { numberOfPages, setPage } = this.props;

    if (e.target.value.length > numberOfPages.toString().length) {
      e.target.value = e.target.value.slice(0, numberOfPages.toString().length);
    }

    if (e.keyCode === 13) {
      if (parseInt(e.target.value, 10) > parseInt(e.target.max, 10)) {
        e.target.value = e.target.max;
      }
      setPage(Number(e.target.value));
    }
  };

  render() {
    const { className, uiStore } = this.props;
    const { isDesktop } = uiStore;

    let paginationContainerClasses = [s.paginationContainer];

    if (className) paginationContainerClasses.push(className);

    return (
      <div className={paginationContainerClasses.join(" ")}>
        {!isDesktop && this.renderPageIndicatorText()}
        <Col xs={"10 offset-1"} lg={"12 offset-lg-0"} className={s.progressbarWrapper}>
          <Progressbar
            percent={this.calculateProgress()}
            className={s.paginationProgressbar}
          />
        </Col>
        <div className={s.paginationControlContainer}>
          <div
            className={s.previousPageButtonContainer}
            onClick={this.onPreviousPageClick}
          >
            <img src={Icons.previous_large} alt="Back arrow" />
          </div>
          <div className={s.centerControlsContainer}>
            {isDesktop && this.renderPageIndicatorText()}
            {this.renderPageButtonsContainer()}
            {isDesktop && this.renderJumpToPage()}
          </div>
          <div className={s.nextPageButtonContainer} onClick={this.onNextPageClick}>
            <img src={Icons.next_large} alt="Forward arrow" />
          </div>
        </div>
      </div>
    );
  }
}
